interface HeaderFixState {
  isVisible: boolean
  type: 'headerType01' | 'headerType02'
  showBackButton: boolean
  step: number
  backButtonText: string
  onBackClick?: () => void
}

export const useHeaderFix = () => {
  const state = useState<HeaderFixState>('headerFix', () => ({
    isVisible: true, // 기본적으로 표시
    type: 'headerType01', // 기본 헤더 타입
    showBackButton: false,
    step: 0,
    backButtonText: '돌아가기',
    onBackClick: undefined,
  }))

  const show = () => {
    state.value.isVisible = true
  }

  const hide = () => {
    state.value.isVisible = false
  }

  const setHeaderType = (type: 'headerType01' | 'headerType02') => {
    state.value.type = type
  }

  const setBackButton = (options: {
    show: boolean
    text?: string
    onClick?: () => void
  }) => {
    state.value.showBackButton = options.show
    if (options.text) state.value.backButtonText = options.text
    if (options.onClick) state.value.onBackClick = options.onClick
  }

  const setStep = (step: number) => {
    state.value.step = step
  }
  const reset = () => {
    state.value.type = 'headerType01'
    state.value.showBackButton = false
    state.value.backButtonText = '돌아가기'
    state.value.onBackClick = undefined
    state.value.step = 0
  }

  return {
    state,
    show,
    hide,
    setHeaderType,
    setBackButton,
    setStep,
    reset,
  }
}
